<template>
  <div class="page">
    <el-tabs v-model="form.DataType" type="card" @tab-click="handleClick">
      <el-tab-pane :label="`未接单（${overview.unTakeOrdersCount || 0}）`" name="1"></el-tab-pane>
      <el-tab-pane :label="`接单处理中（${overview.inProgressCount || 0}）`" name="2"></el-tab-pane>
      <el-tab-pane :label="`处理完成（${overview.handleCompletedCount || 0}）`" name="3"></el-tab-pane>
      <el-tab-pane :label="`全部（${overview.count || 0}）`" name="null"></el-tab-pane>
    </el-tabs>
    <el-form label-width="120px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="工单类型" prop="WorkOrderType">
            <el-select style="width: 100%;" v-model="form.WorkOrderType">
              <el-option label="全部" :value="null" />
              <!-- <el-option label="咨询" :value="1" /> -->
              <!-- <el-option label="其他" :value="3" /> -->
              <el-option label="物流" :value="4" />
              <el-option label="报装" :value="5" />
              <el-option label="错发漏发" :value="6" />
              <el-option label="订单截图" :value="7" />
              <el-option label="更改信息" :value="8" />
              <!-- <el-option label="换货" :value="9" /> -->
              <el-option label="退货退款" :value="10" />
              <!-- <el-option label="物流超区" :value="12" /> -->
              <!-- <el-option label="预售" :value="13" /> -->
              <!-- <el-option label="超时发货" :value="14" /> -->
              <!-- <el-option label="无货" :value="15" /> -->
              <el-option label="非退换售后" :value="17" />
              <el-option label="勘测发货" :value="16" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="工单内容关键字" prop="WorkOrderContent">
            <el-input v-model="form.WorkOrderContent"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="相关订单" prop="ChildOrderNo">
            <el-input v-model="form.ChildOrderNo"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="只看新反馈" prop="OnlyFollowUp">
            <el-select style="width: 100%;" v-model="form.OnlyFollowUp">
              <el-option label="全部" :value="null" />
              <el-option label="是" :value="true" />
              <el-option label="否" :value="false" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="提交时间">
            <el-date-picker style="width: 100%;" v-model="submitTime" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="接单时间">
            <el-date-picker style="width: 100%;" v-model="takeOrdersTime" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="处理完成时间">
            <el-date-picker style="width: 100%;" v-model="handleTime" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <div style="display: flex;">
              <el-button type="primary" @click="searchFun">查询</el-button>
              <el-button @click="resetFun">重置</el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="margin-bottom: 15px;">
      <!-- <el-button type="success" @click="exportBtn">导出</el-button> -->
      <el-button type="primary" @click="handleBatchTakeOrders" v-if="form.DataType==1">批量接单</el-button>
    </div>
    <!--列表-->
    <el-table :data="tableData" border style="width: 100%;" :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" :selectable="selectable"></el-table-column>
      <el-table-column label="工单类型" prop="workOrderTypeName" width="100"></el-table-column>
      <el-table-column label="工单内容" width="200">
        <template slot-scope="scope">
          <p>{{ scope.row.workOrderContent }}</p>
          <!-- <el-tag type="danger" style="margin-top:5px" size="small" v-if="scope.row.isDistributionOrder">超时</el-tag> -->
        </template>
      </el-table-column>
      <el-table-column label="相关订单" width="200">
        <template slot-scope="scope">
          <p class="ChildOrderNo" @click="orderDetial(scope.row)">{{ scope.row.childOrderNo }}</p>
          <!-- <el-tag type="danger" style="margin-top:5px" size="small" v-if="scope.row.newOrderIndex">新客：{{
            scope.row.NewOrderIndex }}单</el-tag>
          <el-tag type="danger" style="margin-top:5px" size="small" v-if="scope.row.newActivateIndex">沉默激活：{{
            scope.row.NewActivateIndex }}单</el-tag>
          <el-button type="text" @click="checkRecord(scope.row)" v-if="scope.row.historyCount > 0">历史工单（{{
            scope.row.HistoryCount }}）</el-button> -->
        </template>
      </el-table-column>
      <el-table-column label="相关商品" prop="proName" width="200"></el-table-column>
      <el-table-column label="图片" min-width="330">
        <template slot-scope="scope">
          <div v-if="scope.row.picList">
            <el-image style="width: 100px; height: 100px" v-for="(item, index) in scope.row.picList" :src="item"
              :key="index" :preview-src-list="scope.row.picList" @click.stop="handleImgClose">
            </el-image>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="最近跟进" min-width="330">
        <template slot-scope="scope">
          <div v-if="scope.row.latestFollowUpInfo">
            <p>{{ scope.row.latestFollowUpInfo.remark }}</p>
            <el-image style="width: 100px; height: 100px" v-for="(item, index) in scope.row.latestFollowUpInfo.picList"
              :key="index" :src="item" :preview-src-list="scope.row.latestFollowUpInfo.picList"
              @click.stop="handleImgClose">
            </el-image>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="workOrderStatusName" width="150"></el-table-column>
      <el-table-column label="接单人" prop="customerService" width="150" v-if="form.DataType != 1"></el-table-column>
      <el-table-column label="接单时间" prop="takeOrdersTime" width="180" v-if="form.DataType != 1"></el-table-column>
      <el-table-column label="提交时间" prop="submitTime" width="180"></el-table-column>
      <el-table-column label="处理完成时间" prop="handleTime" width="180"></el-table-column>
      <el-table-column label="操作" fixed="right" width="150">
        <template slot-scope="scope">
          <div>
            <el-button type="primary" size="small" @click="handleDetail(scope.row)">详情</el-button>
            <el-button type="primary" size="small" @click="handleTakeOrders(scope.row, 1)"
              v-if="scope.row.allowTakeOrders">接单</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]">
    </el-pagination>
    <!-- 详情 -->
    <el-dialog title="详情" :visible.sync="dialogVisibleDetail" width="80%" class="detail-dialog"
      :before-close="HandleDetailClose">
      <el-form ref="detailForm" :model="detailForm" label-width="100px">
        <!-- <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="提交人：">{{ detail.submitter }} <el-tag type="danger" size="small"
                v-if="detail.isDistributionOrder">超时</el-tag></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="提交人类型：">{{ detail.submitterTypeName }}</el-form-item>
          </el-col>
        </el-row> -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="工单类型：">
              <el-select v-model="detail.workOrderType" :disabled="WorkOrderTypeDisabled" placeholder="请选择">
                <el-option v-for="item in [
                  // { label: '咨询', value: 1 },
                  { label: '物流', value: 4 },
                  { label: '报装', value: 5 },
                  { label: '错发漏发', value: 6 },
                  { label: '订单截图', value: 7 },
                  { label: '更改信息', value: 8 },
                  // { label: '换货', value: 9 },
                  { label: '退货退款', value: 10 },
                  // { label: '物流超区', value: 12 },
                  // { label: '预售', value: 13 },
                  // { label: '超时发货', value: 14 },
                  // { label: '无货 ', value: 15 },
                  { label: '非退换售后', value: 17 },
                  { label: '勘测发货', value: 16 },
                  // { label: '其他', value: 3 },
                ]" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <!-- <el-button style="margin-left:10px ;" :type="'primary'" @click="ChangeWorkOrderType">{{
                WorkOrderTypeDisabled ? "修改" : "保存" }}</el-button> -->
              <!-- {{ detail.WorkOrderTypeName }} -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工单内容：">{{ detail.workOrderContent }}</el-form-item>
          </el-col>
        </el-row>
        <div class="detail">
          <el-form-item label="图片：">
            <el-image style="width: 100px; height: 100px" v-for="(item, index) in detail.picList" :src="item"
              :key="index" :preview-src-list="detail.picList" @click.stop="handleImgClose">
            </el-image>
          </el-form-item>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="相关订单：">{{ detail.childOrderNo }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="相关商品：">{{ detail.proName }}</el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="状态：">{{ detail.workOrderStatusName }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="接单人：">
                {{ detail.customerService }}
                <!-- <el-button
                  v-show="detail.workOrderStatus === 1 || detail.workOrderStatus === 2 || detail.workOrderStatus === 4"
                  v-for="button in buttonList_table.filter(b => b.Func === 'handleChangeCustomerService')"
                  :key="button.id" size="small" :type="button.Func && button.Func.toLowerCase().indexOf('del') != -1
                    ? 'danger'
                    : button.Func &&
                      button.Func.toLowerCase().indexOf('det') != -1
                      ? 'primary'
                      : 'success'
                    " @click="handleChangeCustomerService">{{ button.name }}</el-button> -->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="提交时间：">{{ detail.submitTime }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="接单时间：">{{ detail.takeOrdersTime }}</el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="处理时间：">{{ detail.handleTime }}</el-form-item>
          <el-form-item label="处理结果：">
            <template v-if="detail.handleResultObj">
              <p>{{ detail.handleResultObj.remark }}</p>
              <el-image style="width: 100px; height: 100px" v-for="(item, index) in detail.handleResultObj.picList"
                :key="index" :src="item" :preview-src-list="detail.handleResultObj.picList"
                @click.stop="handleImgClose">
              </el-image>
            </template>
          </el-form-item>
        </div>
        <!-- <el-form-item label="同步给商户：">
          <el-switch v-model="detail.allowBusinessUserView" @change="SetAllowBusinessUserView" disabled>
          </el-switch>
        </el-form-item>
        <el-form-item label="同步给采销：">
          <el-switch v-model="detail.allowPurchaseUserView" @change="SetAllowPurchaseUserView" disabled>
          </el-switch>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handleTakeOrders(detail, 2)"
            v-if="detail.workOrderStatus === 1 || detail.workOrderStatus === 4">接单</el-button>
          <!-- <el-button type="primary" @click="disposeVisible = true" v-if="detail.workOrderStatus === 2">处理完成</el-button> -->
        </el-form-item>
        <template v-if="detail.workOrderStatus === 2">
          <el-form-item prop="remark" :rules="[
            { required: true, message: '请输入', trigger: 'blur' },
          ]" label="处理跟进">
            <el-input v-model="detailForm.remark" type="textarea" :autosize="{ minRows: 3 }"></el-input>
            <!-- <div>
              快捷话术：<el-tag type="primary" size="small" v-for="(item, i) in wordsTypeList" :key="i" effect="plain"
                style="margin-right:15px;cursor:pointer" @click="handleShowWordDetailList(i)">{{ item }}</el-tag>
            </div> -->
          </el-form-item>
          <el-form-item prop="picList" label=" ">
            <div class="img_box" v-for="(item, index) in detailForm.picList" :key="index">
              <p class="del_box" @click.stop="handleDelPic(index, 'detailForm')">
                <img src="../../../assets/del-icon.png" alt />
              </p>
              <img :src="item" alt />
            </div>
            <el-upload class="avatar-uploader border-one" action :show-file-list="false" :auto-upload="false"
              :on-change="(file) => handleCustomerPic(file, 'detailForm')" multiple>
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <!-- <div class="detail"> -->
          <!-- <el-form-item label="同步给商户：" prop="allowBusinessUserView" >
            <el-switch v-model="detailForm.allowBusinessUserView" disabled>
            </el-switch>
          </el-form-item>
          <el-form-item label="同步给采销：" prop="allowPurchaseUserView" >
            <el-switch v-model="detailForm.allowPurchaseUserView" disabled>
            </el-switch>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="HandleWorkOrderFollowUp">提交</el-button>
          </el-form-item>
        </template>
        <div class="detail">
          <el-form-item label="跟进记录：">
            <ul>
              <li v-for="(item, index) in detail.followUpList" :key="index" class="followUpList">
                <p>{{ item.remark }}</p>
                <el-image style="width: 100px; height: 100px" v-for="(pic, i) in item.picList" :src="pic" :key="i"
                  :preview-src-list="item.picList" @click.stop="handleImgClose">
                </el-image>
                <p>{{ item.followUpPeople }}&nbsp;&nbsp;&nbsp;&nbsp;{{ item.time }}</p>
                <!-- <div style="display: flex">
                  <p> 同步给商户：<el-switch v-model="item.allowBusinessUserView"
                      @change="FollowUpListAllowBusinessUserView(item)"></el-switch></p>
                  <p style="margin-left: 15px;"> 同步给采销：<el-switch v-model="item.allowPurchaseUserView"
                      @change="FollowUpListAllowBusinessUserView(item)"></el-switch></p>
                </div> -->
              </li>
            </ul>
          </el-form-item>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetAllReseller,
  KSAXApiRequest,
  getQiniuToken
} from "../../../api/api";
import { getButtonList } from "../../../promissionRouter";
import Toolbar from "../../../components/Toolbar";
export default {
  components: { Toolbar },
  data() {
    return {
      overview: {},
      form: {
        SupId: 0,
        PageIndex: 1,
        PageSize: 10,
        DataType: '1',
        WorkOrderType: null,
        OnlyFollowUp: null,
        WorkOrderContent: null,
        ChildOrderNo: null,
        MinSubmitTime: null,
        MaxSubmitTime: null,
        MinTakeOrdersTime: null,
        MaxTakeOrdersTime: null,
        MinHandleTime: null,
        MaxHandleTime: null,
      },
      total: 0,
      tableData: [],
      submitTime: null,
      takeOrdersTime: null,
      handleTime: null,
      detail: {},
      detailForm: {
        workOrderId: null,
        remark: null,
        picList: [],
        allowBusinessUserView: false,
        allowPurchaseUserView: false
      },
      WorkOrderTypeDisabled: true,
      dialogVisibleDetail: false,
      multipleSelection: [],
      qiniuToken: ''
    };
  },
  watch: {
    submitTime(n, o) {
      this.form.MinSubmitTime = n ? n[0] : null;
      this.form.MaxSubmitTime = n ? n[1] : null;
    },
    takeOrdersTime(n, o) {
      this.form.MinTakeOrdersTime = n ? n[0] : null;
      this.form.MaxTakeOrdersTime = n ? n[1] : null;
    },
    handleTime(n, o) {
      this.form.MinHandleTime = n ? n[0] : null;
      this.form.MaxHandleTime = n ? n[1] : null;
    },
  },
  created() {
    GetAllReseller().then(res => {
      if (res.data.result.items.length) {
        this.form.SupId = Number(res.data.result.items[0].remoteKey)
        this.getOverview()
        this.getTableList();
      }
    })
  },
  methods: {
    handleCustomerPic(file, form) {
      let that = this;
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.png`,
        token: that.qiniuToken,
      };
      that.$utils
        .uploadImgToQiniu(file.raw, qiniuData)
        .then((res) => {
          that[form].picList.push(res);
        })
        .catch((err) => {
          that.$message.error(err);
        });
    },
    handleImgClose() {
      this.$nextTick(() => {
        let domImageView = document.querySelector(".el-image-viewer__mask"); // 获取遮罩层dom
        if (!domImageView) {
          return;
        }
        domImageView.addEventListener("click", () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector(".el-image-viewer__close").click();
        });
      })
    },
    SetAllowBusinessUserView() { },
    SetAllowPurchaseUserView() { },
    handleClick(tab, event) {
      setTimeout(() => {
        this.getTableList();
      }, 100);
    },
    handleBatchTakeOrders() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请先选择要接单的工单！');
        return;
      }
      this.$confirm('是否确认批量接单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const workOrderIds = this.multipleSelection.map(item => item.workOrderId);
        this.type = 1
        this.takeOrder(workOrderIds.join(','))
      }).catch(() => { });
    },
    handleTakeOrders(row, type) {
      this.type = type
      this.$confirm('是否确认接单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.takeOrder(row.workOrderId)
      }).catch(() => { });
    },
    takeOrder(ids) {
      let data = {
        path: 'ERPWorkOrder/TakeOrders',
        parmsJson: { SupId: this.form.SupId, workOrderId: ids }
      }
      KSAXApiRequest(data).then(res => {
        if (res.data.success) {
          this.$message.success('操作成功')
          if (this.type == 2) {
            this.getDetail(row)
          }
          this.getTableList()
          this.getOverview()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    HandleDetailClose() {
      this.dialogVisibleDetail = false
      if (this.$refs["detailForm"]) {
        this.$refs["detailForm"].resetFields();
      }
    },
    HandleWorkOrderFollowUp() {
      this.$refs["detailForm"].validate((valid) => {
        if (valid) {
          this.$confirm('是否确认提交跟进?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.detailForm.workOrderId = [this.detail.workOrderId]
            let data = {
              path: 'ERPWorkOrder/FollowUp',
              parmsJson: { SupId: this.form.SupId, ...this.detailForm }
            }
            KSAXApiRequest(data).then(res => {
              if (res.data.success) {
                this.$message.success('操作成功')
                this.$refs["detailForm"].resetFields();
                this.getTableList()
                this.getDetail(this.detail)
                this.getOverview()
              } else {
                this.$message.error(res.data.msg)
              }
            })
          }).catch(() => { });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleDetail(row) {
      this.detail = {}
      this.detailForm = {
        workOrderId: null,
        remark: null,
        picList: [],
        allowBusinessUserView: false,
        allowPurchaseUserView: false
      }
      this.dialogVisibleDetail = true;
      this.getDetail(row, () => {
        this.detailForm.allowBusinessUserView = this.detail.workOrderType == 16
      })
      this.getQiniuToken()
    },
    getDetail(row, cb) {
      let data = {
        path: 'ERPWorkOrder/Detail',
        parmsJson: { workOrderId: row.workOrderId, SupId: this.form.SupId }
      }
      KSAXApiRequest(data).then(res => {
        if (res.data.success) {
          this.detail = res.data.response
          cb()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    //获取七牛token
    getQiniuToken() {
      getQiniuToken().then((res) => {
        this.qiniuToken = res.data
      }).catch(() => { });
    },
    exportBtn() {
      // OrderExport(this.form).then(res => {
      //   let blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
      //   let objectUrl = URL.createObjectURL(blob)
      //   const a = document.createElement('a')
      //   a.download = '订单列表数据.xlsx'
      //   a.href = objectUrl
      //   a.click()
      //   a.remove()
      // })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val || [];
    },
    selectable(row, index) {
      return this.form.DataType == 1
    },
    getOverview() {
      let data = {
        path: 'ERPWorkOrder/GetOverview',
        parmsJson: { SupId: this.form.SupId }
      }
      KSAXApiRequest(data).then(res => {
        if (res.data.success) {
          this.overview = res.data.response
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    async getTableList() {
      this.listLoading = true;
      let json = { ...this.form, DataType: Number(this.form.DataType) }
      if (json.OnlyFollowUp === null) delete json.OnlyFollowUp
      let data = {
        path: 'ERPWorkOrder/MyWorkOrderPage',
        parmsJson: json
      }
      KSAXApiRequest(data).then(res => {
        if (res.data.success) {
          this.tableData = res.data.response.data
          this.total = res.data.response.dataCount;
        } else {
          this.$message.error(res.data.msg)
        }
        setTimeout(() => {
          this.listLoading = false;
        }, 500);
      })
    },
    searchFun() {
      this.form.PageIndex = 1;
      this.getTableList();
    },
    resetFun() {
      this.form = {
        SupId: this.form.SupId,
        PageIndex: 1,
        PageSize: 10,
        DataType: this.form.DataType,
        WorkOrderType: null,
        OnlyFollowUp: null,
        WorkOrderContent: null,
        ChildOrderNo: null,
        MinSubmitTime: null,
        MaxSubmitTime: null,
        MinTakeOrdersTime: null,
        MaxTakeOrdersTime: null,
        MinHandleTime: null,
        MaxHandleTime: null,
      };
      this.submitTime = null
      this.takeOrdersTime = null
      this.handleTime = null
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.form.PageIndex = val;
      this.getTableList();
    },
    handleSizeChange(e) {
      this.form.PageSize = e;
      this.getTableList();
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      const toolBarButtonList = buttonList.filter((item) => {
        return item.buttonShow === 10;
      });
      this.buttonList_toolBar = toolBarButtonList;
      const tableButtonList = buttonList.filter((item) => {
        return item.buttonShow === 20;
      });
      this.buttonList_table = tableButtonList;
    }
  },
};
</script>

<style scoped>
.img_box {
  width: 120px;
  height: 120px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  float: left;
  position: relative;
  margin-right: 10px;
}

.img_box img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
}

.del_box {
  position: absolute;
  top: -25px;
  right: -10px;
  width: 20px;
  height: 20px;
}

.del_box img {
  height: 100%;
  width: 100%;
}

.el_upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  height: 100%;
  width: 100%;
}

.el-upload img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 120px;
  height: 120px;
  display: inline-block;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  text-align: center;
  line-height: 120px;
}
</style>
